export default __webpack_public_path__ + "static/fonts/HelveticaNeue.9849a4c.woff";